export default __webpack_public_path__ + "static/media/empEzy3.a00aa584.jpg";